import Vue from 'vue';
import Vuetify from 'vuetify';
import { Theme } from '@/config/theme';
import Page from '@/plugins/Page';
import debounce from 'debounce';
import Breadcrumb from '@/plugins/Breadcrumb';
import Carousel3d from 'vue-carousel-3d';

var VueTouch = require('vue-touch')
Vue.use(VueTouch)
Vue.use(Carousel3d);

Vue.use(Page);
Vue.use(Breadcrumb);

Vue.use(Vuetify, {
  theme: Theme,
});

Vue.prototype.$debounce = debounce(function(this: any, methodName: string, ...parameters: any[]) {
  (this as any)[methodName].call(this as any, ...parameters);
}, 300);
